import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Typography } from "@mui/material"
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import CloseIcon from '@mui/icons-material/Close'
import { usePinTokenState } from "../../../../context/pin-state/PinState"

export function BasePinErrorDialog(headerText: string, bodyText: string) {
  const { setPinToken } = usePinTokenState()

  function handleTryAgain() {
    setPinToken(null)

    // default action: reload page?
    window.location.reload()
  }

  return (
    <Dialog
      open={true}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      disableEscapeKeyDown={true}
      sx={{
        '.MuiPaper-root': { minWidth: '330px' },
      }}
    >
      <DialogTitle id="alert-dialog-title" sx={{
        display: 'flex', justifyContent: 'space-between', ml: -1
      }}>
        <Box sx={{
          display:'flex', justifyContent: 'left', alignItems: 'center', mr: 4,
        }}>
          <ErrorOutlineIcon fontSize='large' color='error' sx={{ mr: 1 }} />
          <Typography sx={{
            fontWeight: '500', lineHeight: '18px',
          }}>
            {headerText}
          </Typography>
        </Box>
        <IconButton
          aria-label="close"
          onClick={handleTryAgain}
          sx={{
            position: 'absolute',
            right: 6,
            top: 6,
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {bodyText}
        </DialogContentText>
      </DialogContent>

      <DialogActions sx={{ m: 1 }}>
        <Button
          onClick={handleTryAgain}
          sx={{
            borderRadius: "100px", textTransform: 'none', ml: 1,
          }}
        >
          {'Refresh Page'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
